<template>
  <v-container fluid class="d-flex justify-center pa-0 flex-wrap container__wrap">
    <v-card width="1360" class="mt-15 pt-8 pb-5 search_list">
      <search-form @reset="reset" @search="search"></search-form>
    </v-card>
    <v-card width="1360" class="mt-5 mb-12 table_list_wrap table_list_wrap_user">
      <v-card-text class="px-8 py-5 d-flex justify-space-between align-center table_list_bar">
        <div class="table_list_bar_text">
          환자 찾기 결과
          <span>(총 {{ paging.totalElements }}명)</span>
        </div>
        <div class="d-flex align-center">
          <div class="mr-10">
            <v-checkbox v-model="isPhotographed" label="촬영한 환자만 보기" color="primary" class="mt-0" hide-details @change="showPhotographedList"></v-checkbox>
          </div>
          <div class="select_wrap">
            <select-box v-model="cellRange" :items="cellRangeItems" height="36" @fieldChanged="changeCellRange"></select-box>
          </div>
        </div>
      </v-card-text>
      <v-data-table
        :headers="userListHeaders"
        :items="usersList"
        :items-per-page="cellRange"
        :custom-sort="customSort"
        fixed-header
        hide-default-footer
        no-data-text="데이터가 존재하지 않습니다."
        class="table_wrap"
        page.sync="page"
        :loading="tableLoading">
        <template #item="row">
          <tr>
            <td class="link" @click="showResultPopup(row.item.id)">{{ row.item.num }}</td>
            <td class="link" @click="showResultPopup(row.item.id)">{{ row.item.name }}</td>
            <td class="link" @click="showResultPopup(row.item.id)">
              {{ !!row.item.number ? $convertTelFormat(row.item.number) : '-' }}
            </td>
            <td class="link" @click="showResultPopup(row.item.id)">
              {{ !!row.item.birth ? $convertDateFormat('YYYYMMDDKR', row.item.birth) : '-' }}
            </td>
            <td class="link" @click="showResultPopup(row.item.id)">
              {{ !!row.item.gender ? genderStatus.find(gender => gender.value === row.item.gender).text : '-' }}
            </td>
            <td class="link" @click="showResultPopup(row.item.id)">{{ row.item.totalCount }}회</td>
            <td class="link" @click="showResultPopup(row.item.id)">
              {{ !!row.item.latestDate ? $convertDateFormat('YYYYMMDDDayKR', row.item.latestDate) : '-' }}
            </td>
            <td class="link" @click="showResultPopup(row.item.id)">
              {{ !!row.item.latestState ? healthStatus[row.item.latestState].text : '-' }}
            </td>
            <td class="link" @click="showResultPopup(row.item.id)">
              {{ !!row.item.isCertified ? certStatus.find(cert => cert.value === row.item.isCertified).text : '-' }}
            </td>
            <!--<td style="z-index: 999">-->
            <!--  <button @click.stop="editUser(row.item)">-->
            <!--    <v-icon>mdi-pencil</v-icon>-->
            <!--  </button>-->
            <!--  <button class="ml-7" @click.stop="showDeletePopup(row.item)">-->
            <!--    <v-icon>mdi-delete</v-icon>-->
            <!--  </button>-->
            <!--</td>-->
            <td v-if="row.item.isCertified !== 'Y'" style="padding: 0">
              <button class="delete_btn" @click="showCertPopup(row.item)">회원인증</button>
            </td>
            <td v-else>-</td>
          </tr>
        </template>
      </v-data-table>
      <v-pagination
        :value="paging.number"
        total-visible="10"
        class="my-4"
        :length="paging.totalPages"
        @input="changePage({ query: $route.query, currentPage: paging.number, clickedPage: $event })"></v-pagination>
    </v-card>
    <popup v-model="showPopup" :popup="popup" @close="closePopup" @submit="submitPopup">
      <template #special>
        <delete-popup-form v-if="popup.special === 'user_delete'" v-model="deletePopupText" :data="popup.data" :content="popup.content" @close="closePopup" @submit="submitPopup"></delete-popup-form>
      </template>
    </popup>
    <user-result-popup v-model="showResult" :data="resultData" @close="closeResultPopup" @error="resultError" />
  </v-container>
</template>

<script>
import Api from '@/apis/api';
import Popup from '@/components/common/Popup';
import DeletePopupForm from '@/components/forms/DeletePopupForm';
import UserResultPopup from '@/components/status/UserResultPopup';
import SelectBox from '@/components/common/SelectBox';
import SearchForm from '@/components/forms/SearchForm';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'List',
  components: {
    Popup,
    SearchForm,
    DeletePopupForm,
    UserResultPopup,
    SelectBox,
  },
  data: () => ({
    showPopup: false,
    popup: {
      type: '',
      header: '',
      content: '',
      btnType: '',
      center: '',
      special: '',
      data: '',
    },
    deletePopupText: '',
    active: {},
    isPhotographed: false,
    paging: {
      number: 1,
      totalElements: 0,
      totalPages: 1,
    },
    cellRange: 50,
    usersList: [],
    tableLoading: true,
    todayDate: '',
    showResult: false,
    resultData: {
      latestDate: '',
      name: '',
      phoneNumber: '',
      photo: '',
      resultType: '',
      upPercent: 0,
      downPercent: 0,
      resultComment: '',
    },
  }),
  computed: {
    ...mapGetters('table', ['getTableList']),
    ...mapState('commonValue', ['healthStatus', 'genderStatus', 'certStatus', 'cellRangeItems', 'userListHeaders']),
  },
  watch: {
    '$route.query'() {
      this.getList();
    },
  },
  created() {
    this.setTodayDate();
    this.getList();
  },
  methods: {
    ...mapActions('table', ['changePage']),
    getList() {
      this.tableLoading = true;
      this.paging.number = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
      this.cellRange = this.$route.query.size ? parseInt(this.$route.query.size) : 50;
      let form = {
        page: this.paging.number,
        size: this.cellRange,
      };
      for (const i in this.$route.query) {
        this.isPhotographed = this.$route.query['isPhotographed'] === 'Y';
        if (i !== 'active') form[i] = this.$route.query[i];
      }
      Api.getSoldierList(form).then(res => {
        if (res && res.data.rt === 200) {
          this.paging = res.data.paging;
          this.usersList = this.getTableList(res.data.paging, this.cellRange, res.data.soldierList);
          this.tableLoading = false;
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    customSort(items, index, isDesc) {
      if (!index[0]) return items; // 정렬 없는 경우 그대로 리턴

      items.sort((a, b) => {
        if (!a[index[0]] || !b[index[0]]) return a[index[0]] ? -1 : 1; // 값이 없는게 있으면 맨 아래로 정렬

        let sort;
        if (index[0] === 'latestState') {
          // 구강상태
          sort = this.healthStatus[b.latestState].value - this.healthStatus[a.latestState].value;
        } else {
          sort = a[index[0]] < b[index[0]] ? -1 : 1;
        }

        return !isDesc[0] ? sort : -sort;
      });

      return items;
    },
    showPhotographedList() {
      let query = {};
      Object.assign(query, this.$route.query);
      if (this.isPhotographed) {
        query.isPhotographed = 'Y';
      } else {
        delete query.isPhotographed;
      }
      delete query.page; // 1페이지로 초기화
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.push({ query: query });
      }
    },
    reset() {
      if (JSON.stringify(this.$route.query) !== JSON.stringify({})) {
        this.$router.push({ query: null });
      }
    },
    search(form) {
      for (const i in form) {
        if (!form[i]) {
          delete form[i]; // query에 빈 값으로 key만 출력되는 현상 방지
        }
      }
      if (JSON.stringify(form) !== JSON.stringify(this.$route.query)) {
        this.$router.push({ query: form });
      }
    },
    // moveToStatus(item) {
    //   this.$router.push(`/user/status/${item.id}`);
    // },
    changeCellRange(value) {
      this.$router.push({ query: { size: value } });
    },
    closePopup() {
      this.deletePopupText = '';
      this.showPopup = false;
    },
    submitPopup(type) {
      if (type === 'user_delete') {
        this.deleteUser(this.popup.data);
      } else if (type === 'certify') {
        this.certifyUser(this.popup.data);
      }
      this.closePopup();
    },
    // showDeletePopup(item) {
    //   this.popup = {
    //     type: 'info',
    //     header: '회원 계정 삭제하기',
    //     btnType: '동의',
    //     special: 'user_delete',
    //     content: `계정을 삭제하면 회원 목록에서
    //         <br />
    //         계정정보가 즉시 사라지고 복구가 불가합니다.
    //         <br/>
    //         <br />
    //         또 앱 서비스 이용시 즉시 로그아웃됩니다.
    //        <br/>
    //         삭제 동의하시면 회원 이름을 한번 더 입력해주세요.`,
    //     data: item,
    //   };
    //   this.showPopup = true;
    // },
    showCertPopup(data) {
      this.popup = {
        type: 'info',
        header: '회원 인증하기',
        content: `${data.name}님을 인증하시겠습니까?`,
        btnType: '인증하기',
        data: data,
      };
      this.showPopup = true;
    },
    certifyUser(data) {
      Api.certifySoldier({ solId: data.id }).then(res => {
        if (res && res.data.rt === 200) {
          this.closePopup();
          this.$root.toast.show({
            content: `인증되었습니다.`,
          });
          this.getList();
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    editUser(item) {
      if (item.userCreated) {
        // 이미 가입한 장병의 경우 정보 수정 불가
        this.popup = {
          type: 'info',
          header: '회원정보 수정 불가',
          content: `해당 장병은 'DENTI ROKA' 모바일 어플리케이션을 통해
                    <br/>본인인증을 마쳤습니다.
                    <br/><br/>본인인증을 마친 장병 개인정보는 수정이 불가능합니다.`,
          btnType: '확인',
          center: 'false',
        };
        this.showPopup = true;
        return;
      }

      this.$router.push(`/user/modify/${item.id}`);
    },
    deleteUser(data) {
      Api.deleteSoldier(data).then(res => {
        if (res && res.data.rt === 200) {
          this.closePopup();
          this.$root.toast.show({
            content: `삭제가 완료되었습니다.`,
          });
          this.getList();
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    setTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
      const date = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
      this.todayDate = `${year}-${month}-${date}`;
    },
    getResult(id) {
      this.$root.spinner.set(true);
      Api.getSoldierResult({
        solId: id,
      }).then(res => {
        this.$root.spinner.set(false);
        if (res?.data.rt === 200) {
          const data = res.data;

          this.resultData = {
            latestDate: data.latestDate,
            name: data.name,
            phoneNumber: data.phoneNumber,
            photo: data.photo,
            resultType: data.resultType,
            upPercent: data.upPercent,
            downPercent: data.downPercent,
            resultComment: data.resultComment,
          };
          this.showResult = true;
        } else if (res?.data.rt === 400) {
          this.resultError();
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    showResultPopup(id) {
      this.getResult(id);
    },
    closeResultPopup() {
      this.showResult = false;
    },
    resultError() {
      if (this.showResult) {
        this.closeResultPopup();
      }
      this.popup = {
        type: 'error',
        header: '촬영 데이터 없음',
        content: '촬영된 구강 사진이 없습니다.',
        btnType: '확인',
      };
      this.showPopup = true;
    },
  },
};
</script>

<style scoped></style>
